var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoBlue4Fill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Info_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.99998 1.33203C11.6824 1.33203 14.6677 4.31726 14.6677 7.99973C14.6677 11.6822 11.6824 14.6674 7.99998 14.6674C4.31751 14.6674 1.33228 11.6822 1.33228 7.99973C1.33228 4.31726 4.31751 1.33203 7.99998 1.33203ZM7.99744 6.83242C7.65555 6.83264 7.37393 7.09019 7.33564 7.42177L7.33121 7.49952L7.33361 11.1673L7.33814 11.245C7.37687 11.5765 7.65882 11.8337 8.00071 11.8335C8.3426 11.8333 8.62421 11.5757 8.66251 11.2441L8.66694 11.1664L8.66454 7.49865L8.66 7.42091C8.62128 7.08937 8.33933 6.8322 7.99744 6.83242ZM8.00027 4.33272C7.53948 4.33272 7.16593 4.70627 7.16593 5.16707C7.16593 5.62786 7.53948 6.00141 8.00027 6.00141C8.46107 6.00141 8.83462 5.62786 8.83462 5.16707C8.83462 4.70627 8.46107 4.33272 8.00027 4.33272Z",
    fill: "#166DD7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoBlue4Fill);
export default __webpack_public_path__ + "static/media/icon-Info-blue4-fill.fdab8c0f8c67871957d1a5887b6d5271.svg";
export { ForwardRef as ReactComponent };